/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_HeadingInputs */

const ja_playdata_about_heading = /** @type {(inputs: Playdata_About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATAについて`)
};

const en_playdata_about_heading = /** @type {(inputs: Playdata_About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ABOUT PLAYDATA`)
};

/**
* | output |
* | --- |
* | "ABOUT PLAYDATA" |
*
* @param {Playdata_About_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_heading = /** @type {((inputs?: Playdata_About_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_heading(inputs)
	return en_playdata_about_heading(inputs)
});